import { FC } from 'react';
import { PageContainer } from '@edikk-edikk/country-layout-black';
import { CardLocation } from '#home/components/card-location/CardLocation';
import { SeoText } from '#home/components/SeoText';
import { SeoTextLong } from '#home/components/SeoTextLong';
import homeCss from '#srcCssModules/home/home.module.scss';
import homeTitleCss from '#srcCssModules/home/home-title.module.scss';
import HomeContentCss from '#srcCssModules/home/home-content.module.scss';
import { CardPopularCityList } from '#home/components/card-popular-city-list';
import { useHomeContext } from '#home/hooks';

const Content: FC = () => {
  const { seo } = useHomeContext();

  return (
    <div className={homeCss.home__content}>
      <div className={HomeContentCss.homeContent__top}>
        <h1 className={homeTitleCss.homeTitle}>
          {seo.h1}
        </h1>
        <SeoText />
        <PageContainer additionalClassName={HomeContentCss.homeContent__cardHolder}>
          <CardLocation />
        </PageContainer>
      </div>
      <div className={HomeContentCss.homeContent__bottom}>
        <CardPopularCityList />
        <SeoTextLong />
      </div>
    </div>
  );
};

export { Content };
